/**
 * Canonical site URL for canonical links, Open Graph, JSON-LD.
 * Set at build time: REACT_APP_SITE_URL=https://felasher.com
 */
export function getSiteUrl() {
  const raw = process.env.REACT_APP_SITE_URL || 'https://felasher.com';
  return String(raw).replace(/\/+$/, '');
}
